// extracted by mini-css-extract-plugin
module.exports = {"card":"Card-card-1iGZk","underlay":"Card-underlay-1gZEh","overlay":"Card-overlay-3Uxw8"};